import React from "react";
import {
  RiShieldCheckLine,
  RiHeartPulseLine,
  RiCarLine,
  RiHomeLine,
} from "react-icons/ri";
import { HiCheckCircle } from "react-icons/hi2";
import "../styles/Pages.css";

const InsurePage = ({ user }) => {
  const insuranceProducts = [
    {
      id: "life",
      icon: <RiShieldCheckLine />,
      title: "Life Insurance",
      description: "Comprehensive life cover for you and your family",
      coverage: "Up to R10M",
      premium: "From R250/month",
      benefits: [
        "Death benefit payout",
        "Terminal illness cover",
        "Funeral benefit included",
        "Premium waiver on disability",
      ],
    },
    {
      id: "health",
      icon: <RiHeartPulseLine />,
      title: "Health Insurance",
      description: "Complete medical aid and health coverage",
      coverage: "Unlimited hospital plan",
      premium: "From R3,500/month",
      benefits: [
        "Private hospital care",
        "Specialist consultations",
        "Chronic medication",
        "Emergency medical evacuation",
      ],
    },
    {
      id: "car",
      icon: <RiCarLine />,
      title: "Car Insurance",
      description: "Comprehensive vehicle insurance and roadside assistance",
      coverage: "Retail value",
      premium: "From R650/month",
      benefits: [
        "Accident damage cover",
        "Theft and hijacking",
        "24/7 roadside assistance",
        "Courtesy car included",
      ],
    },
    {
      id: "home",
      icon: <RiHomeLine />,
      title: "Home Insurance",
      description: "Protect your home and belongings",
      coverage: "Building & contents",
      premium: "From R450/month",
      benefits: [
        "Fire and storm damage",
        "Theft and burglary",
        "Natural disasters",
        "Alternative accommodation",
      ],
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Insurance</h1>
        <p className="page-subtitle">Protect what matters most to you</p>
      </div>

      <div className="insurance-products">
        <h3>Available Insurance Products</h3>
        <div className="products-grid">
          {insuranceProducts.map((product) => (
            <div key={product.id} className="insurance-card">
              <div className="insurance-icon">{product.icon}</div>
              <h4>{product.title}</h4>
              <p className="insurance-description">{product.description}</p>

              <div className="insurance-pricing">
                <div className="pricing-item">
                  <span className="pricing-label">Coverage</span>
                  <span className="pricing-value">{product.coverage}</span>
                </div>
                <div className="pricing-item">
                  <span className="pricing-label">Premium</span>
                  <span className="pricing-value">{product.premium}</span>
                </div>
              </div>

              <div className="insurance-benefits">
                <h5>Key Benefits</h5>
                <ul>
                  {product.benefits.map((benefit, idx) => (
                    <li key={idx}>
                      <HiCheckCircle className="benefit-check" />
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>

              <button className="btn-primary">Get a Quote</button>
            </div>
          ))}
        </div>
      </div>

      <div className="insurance-info">
        <div className="info-grid">
          <div className="info-item">
            <h4>Why Choose Our Insurance?</h4>
            <ul className="info-list">
              <li>Competitive premiums with no hidden fees</li>
              <li>Fast and easy claims process</li>
              <li>24/7 customer support</li>
              <li>Trusted by over 500,000 customers</li>
            </ul>
          </div>
          <div className="info-item">
            <h4>Need Help Choosing?</h4>
            <p>
              Speak to one of our insurance advisors who can help you find the
              right coverage for your needs.
            </p>
            <button className="btn-outline">Contact an Advisor</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsurePage;
